import { FormEvent, useEffect, useState } from 'react';
import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil'; // Import connectUtil and PropsFromRedux

import { RootStateAuth } from '../../store/authReducer';

import { View } from 'base/src/components/Basic/View/view';
import StateMensage from 'base/src/view/states/state'

import * as S from './styles';
import { useTheme } from 'base/src/utils/context/themeContext';
import Avatar from 'base/src/components/Avatar';
import StringUtil from 'domain/utils/StringUtils';
import { Input } from 'base/src/components/Input';
import { Forms } from 'base/src/components/Form';
import { useTranslation } from "react-i18next";
import { AuthPerfilRequest } from '../../types/authPerfil/authPerfilRequest';
import PerfilContainer from '../../containers/perfil/perfilContainer';
import { AlterarPerfil } from '../../store/perfil/actions/perfilAction';
import { AutoFormData } from 'domain/utils/FormUtils';
import { InDev } from 'base/src/view/states/inDev';
import { ALTERAR_PERFIL } from '../../types/authPerfil/authPerfil';
import { FileSelector } from 'base/src/components/FileSelector';
import { FileContent } from 'use-file-picker/types';
import { TimePicker } from 'base/src/components/TimePicker';
import { Label } from 'base/src/components/Basic/Label/label';
import { convertToDateInput } from 'base/src/utils/stringUtil';
import { FileType } from 'base/src/types/fileSelector/fileSelectorTypes';

const connector = connectUtil(
  (state: RootStateAuth) => ({
    userData: state.UtilReducer.UserData,
    perfilAtual: state.AuthPerfilReducer.perfilAtual,
  }),
  { AlterarPerfil }
);

export interface PerfilComponentProps extends PropsFromRedux<typeof connector> {}



function AuthPerfil(props: PerfilComponentProps){
  const { theme } = useTheme();
  const { t } = useTranslation();
  const perfilContainer = new PerfilContainer(props);

  const [file, setFile] = useState<FileContent<string>>();
  const [data, setData] = useState<Date | undefined>(props.userData?.DataNascimento);

  function handleForm(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const formData = AutoFormData<AuthPerfilRequest>(event.currentTarget);
    //LogFormData(formData);
    perfilContainer.AlterarPerfil(formData);
  }
  
  useEffect(function syncData() {
    setData(props.userData?.DataNascimento);
  }, [props.userData?.DataNascimento]);

  return (
    <View>
      <S.Container>
        <S.AppCard>
          <InDev />
          {props.userData && (
            <>
              <FileSelector
                overlay={true}
                form={true}
                setFile={setFile}
                name="FotoPerfil"
                multiple={false}
                title="teste"
                accept={[FileType.IMAGE]}
              >
                <Avatar
                  src={file?.content ?? props.userData?.ImagemUrl}
                  borderColor={theme.colors.negative}
                  size={"lg"}
                  alt="top"
                  fallBack={StringUtil.GetFirstLetters(props.userData?.NomeCompleto ?? "N")}
                />
              </FileSelector>

              <Forms handleForm={handleForm} buttonText={t("Alterar")}>
                <S.TextContainer>
                  <Input
                    form={true}
                    name="NomeCompleto"
                    type="text"
                    label="Nome completo"
                    defaultValue={props.userData.NomeCompleto}
                  />
                </S.TextContainer>

                <S.TextContainer>
                  <Input
                    form={true}
                    name="NomeExibicao"
                    label="Nome de exibição"
                    defaultValue={props.userData.NomeExibicao}
                  />
                </S.TextContainer>

                <S.TextContainer>
                  <Input
                    type="email"
                    name="email"
                    form={true}
                    label="Email"
                    defaultValue={props.userData.Email}
                  />
                </S.TextContainer>

                <S.TextContainer>
                  <Input
                    form={true}
                    name="ChavePix"
                    label="Chave Pix"
                    defaultValue={props.userData.ChavePix}
                  />
                </S.TextContainer>

                {data && (
                  <S.TextContainer>
                    <Label>Data de Nascimento</Label>
                    <TimePicker
                      name="DataNascimento"
                      form={true}
                      onChangeData={setData}
                    >
                      <Input type="date" value={convertToDateInput(new Date(data))} />
                    </TimePicker>
                  </S.TextContainer>
                )}
              </Forms>
            </>
          )}
        </S.AppCard>
        <StateMensage stateErrorNames={[ALTERAR_PERFIL]} stateLoadingNames={[ALTERAR_PERFIL]} />
      </S.Container>
    </View>
  );
}

export default connector(AuthPerfil);
